<script setup lang="ts">
    import { computed } from 'vue'
    import type { ScaleTemplateViewerViewModel } from "@Scales/Components/ScaleTemplateViewer"

    /* props */
    const props = defineProps<{
        viewModel: ScaleTemplateViewerViewModel
    }>()

    /* shortcuts */
    const vm = computed(() => props.viewModel)

    /* derived */

    const opened = computed(() => vm.value?.opened ?? false)
    const name = computed(() => vm.value.name)
    const description = computed(() => vm.value.description)
    const levels = computed(() => vm.value.levels)

    /* actions */

    function close()
    {
        vm.value.close()
    }
</script>


<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{name}}</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <p class="lead">{{description}}</p>
                        <p v-for="lvl in levels">
                            <strong>{{lvl.Value}} - {{lvl.Name}}</strong><br />
                            <span>{{lvl.Definition}}</span>
                        </p>
                    </div>
                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>